"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  id: "1",
  title: "Chiropractic Care",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/practitioner_hands_adjustment.png"
}, {
  id: "2",
  title: "Acupuncture & Dry Needling",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/acupuncture_needling_limassol.png"
}, {
  id: "3",
  title: "Sciatica & Disc Program",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/spine_lumbar_decompression.png"
}];
export default function ServicesPreview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="177875" id="services-at-this-location" className="bg-background text-foreground py-16 md:py-24" ref={ref}>
      <div className={`container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 mb-10 md:mb-12">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-foreground tracking-tight">
            Treatments available at our Limassol clinic
          </h2>
          <div className="flex flex-wrap items-center gap-4">
            <Button asChild variant="default" size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-full">
              <Link to="/ContactPage">Schedule Consultation</Link>
            </Button>
            <Button asChild variant="secondary" size="lg" className="bg-secondary text-secondary-foreground hover:bg-secondary/90 rounded-full">
              <Link to="/TreatmentsPage">View All Treatments</Link>
            </Button>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {services.map((service, i) => <div data-index={i} key={service.id}>
              <Card className="h-full overflow-hidden border-none rounded-2xl bg-card/70 backdrop-blur-md shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 ease-in-out p-0 gap-0">
                <img src={service.image} alt={service.title} className="w-full h-56 object-cover" />
                <CardContent className="p-6">
                  <h3 className="text-center font-serif text-xl font-medium text-foreground">
                    {service.title}
                  </h3>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}